import React from "react";
import { DownloadModel } from "../Download/DownloadModel";

import "./VersionPopup.css";

const VersionPopup: React.FC<{
  blok: DownloadModel;
  onButtonClick: (show: boolean) => void;
}> = ({ blok, onButtonClick }) => {
  const handleClick = (show: boolean) => {
    if (onButtonClick) {
      onButtonClick(show);
    }
  };

  return (
    <div className="version-popup-container" onClick={() => handleClick(false)}>
      <div
        className="version-popup-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header">
          <h5>{blok.downloadName} VERSION INFORMATION</h5>
          <button
            className="version-popup-close-button"
            onClick={() => handleClick(false)}
          ></button>
        </div>
        <div className="version-video-wrapper">
          <div className="version-popup-version">
            Version {blok.versionId} | {blok.format} | {blok.platform}
          </div>
          <div className="version-popup-minim-os">{blok.minimalOs}</div>
          <div className="version-popup-minim-os">
            {blok.downloadTypes.join(", ")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VersionPopup;
